<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { defineComponent, ref, toRefs, watch } from '@vue/composition-api';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement } from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement);

export default defineComponent({
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      // default: 400,
    },
    height: {
      type: Number,
      default: 170,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      required: true,
      default: [],
    },
    name: {
      type: String,
      default: 'Chart',
    },
  },
  setup(props) {
    const expo = {};
    const { styles, data, name } = toRefs(props);

    expo.chartData = ref({
      labels: [],
      datasets: [
        {
          label: name.value,
          backgroundColor: styles.value.borderColor,
          borderColor: styles.value.borderColor,
          data: [],
        },
      ],
    });
    expo.chartOptions = ref({
      legend: {
        labels: {
          // This more specific font property overrides the global property
          font: {
            size: 34,
          },
        },
      },
      scales: {
        y: {
          ticks: { color: styles.value.color, beginAtZero: true },
        },
        x: {
          ticks: { color: styles.value.color, beginAtZero: true },
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    });

    watch(
      data,
      (val) => {
        expo.chartData.value.labels = [];
        expo.chartData.value.datasets[0].data = [];
        val.forEach((el) => {
          expo.chartData.value.labels.push(el.tarih);
          expo.chartData.value.datasets[0].data.push(parseFloat(el.toplam).toFixed(2));
        });
      },
      { deep: true, immediate: true }
    );

    return { ...expo };
  },
});
</script>
